import {
  FinishedSessionWithResponsesFragment,
  ModulePublishedResponseFragment,
  ModuleResponseAndCompletionFragment,
  ModuleRevisionResponseFragment,
  PageWithPositionFragment,
  SeriesDiscountSettingsFragment,
  SeriesResponseFragment,
  SeriesWithModulesFragment,
} from './api-types'

export type LearningModuleRevisionType = ModuleRevisionResponseFragment & {
  cme_credits?: number
}

export type LearningModuleType = ModulePublishedResponseFragment & {
  revision: LearningModuleRevisionType
  needs_subscription: boolean
}

export type EarnedCMEType = {
  credits: number
  minutes: number
  accreditor: string
  completed_at: string // ISO8601 date
  certificate_url: string
}

export type LearningModuleWithSessionType =
  ModuleResponseAndCompletionFragment & {
    revision: LearningModuleRevisionType
    needs_subscription: boolean
    earned_cme?: EarnedCMEType
  }

export type LearningSeriesType = SeriesResponseFragment & {
  applicable_discount: SeriesDiscountSettingsFragment
  earned_cme?: EarnedCMEType
}
export type LearningSeriesWithModulesType = Omit<
  SeriesWithModulesFragment,
  'modules'
> & {
  applicable_discount: SeriesDiscountSettingsFragment
  modules: LearningModuleType[]
  cme_credits?: number
  expected_completion_time_minutes?: number
}

export type LearnerModuleReflections = { body: string }

export type LearningModuleRevisionPageType = PageWithPositionFragment
export type LearningPage = PageWithPositionFragment & { _editorID?: string }
export type LearningSessionFinished = FinishedSessionWithResponsesFragment
export type LearningSessionFinishedWithoutResponses = Omit<
  LearningSessionFinished,
  'revision' | 'responses' | 'events'
>

export type LearningSessionScore = Pick<
  FinishedSessionWithResponsesFragment,
  'marks' | 'marks_available' | 'active' | 'finished_at' | 'status'
>
export type LearningModuleRevisionScore = Pick<
  LearningModuleRevisionType,
  'mcq_settings_pass_mark' | 'mcq_settings_pass_mark_type'
>

export enum LearningModuleEventType {
  start = 'start',
  answer = 'answer',
  finish = 'finish',
}
export enum McqSettingsPassMarkType {
  none = 'none',
  percentage = 'percentage',
  absolute = 'absolute',
}
